"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  level: {
    id: "window.characterTable.header.level",
    defaultMessage: "Level",
    description: ""
  },
  name: {
    id: "window.characterTable.header.name",
    defaultMessage: "Name",
    description: ""
  },
  status: {
    id: "window.characterTable.header.status",
    defaultMessage: "Stat.",
    description: ""
  },
  on: {
    id: "window.characterTable.entry.status.on",
    defaultMessage: "ON",
    description: ""
  },
  off: {
    id: "window.characterTable.entry.status.off",
    defaultMessage: "OFF",
    description: ""
  }
});

exports.default = _default;